export const TEST = 'TEST';
export const marketing = "marketing";
export const SELLERSIGNFN = 'SELLERSIGNFN';//获取短信签名
export const MODELTITLE = 'MODELTITLE';//存取短信模板title
export const LOGINUSERINFO = 'LOGINUSERINFO';//存取短信模板title
export const CITYPROVINCEDATA = 'CITYPROVINCEDATA'; //省市数据
export const POINTUSERINFO = 'POINTUSERINFO';//存取短信模板title
export const SHOPINFO = 'SHOPINFO'; // 店铺信息